module.exports = __webpack_public_path__ + "assets/img/00064.6a7a8176.png";